import React from 'react';
import Layout from "../components/layout"
import Styles from "../components/aboutus.module.css"
import Cart from "../components/cart/cart"
class cart extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {  }
    render() { 
        return ( 
            <Layout>
           <>
                    <div className={Styles.aboutus_bannerimage}>
                        <div className={Styles.overlay}></div>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12">
                                    <div className={Styles.text}>
                                        <h2>Cart</h2>
                                        <p>Here is a list of your cart items</p>
                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container bg-white rounded-top mt-5" id="zero-pad">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-10 col-12 pt-3 pb-3">
                             
                                <div className="d-flex flex-column pt-4">
                                    <div><h5 className="text-uppercase font-weight-normal">shopping bag </h5><span className='badge'>2 items</span> </div>
                                    
                                </div>
                                <div className="d-flex flex-row px-lg-5 mx-lg-5 mobile" id="heading">
                                    <div className="px-lg-5 mr-lg-5" id="produc">PRODUCTS</div>
                                    <div className="px-lg-5 ml-lg-5" id="prc">PRICE</div>
                                    <div className="px-lg-5 ml-lg-1" id="quantity">QUANTITY</div>
                                    <div className="px-lg-5 ml-lg-3" id="total">TOTAL</div>
                                </div>
                                <Cart />
                              

                            </div>
                        </div>
                    </div>
                 




           </>
            </Layout>
         );
    }
}
 
export default cart;